<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="500">
      <v-card light>
        <v-card-title class="headline">Confirmar terminación de condición</v-card-title>
        <v-card-text>Seleccione fecha de cierre para la condición</v-card-text>
        <DatePickerForm class="mr-4 ml-4" v-model="fechaCierre" required :error-messages="fechaCierreErrors"
          label="Fecha de cierre"></DatePickerForm>
        <v-textarea class="mr-4 ml-4" v-model="motivoCierre" label="Motivo de cierre" required :error-messages="motivoCierreErrors"></v-textarea>
        <v-card-actions>
          <v-btn color="error" flat @click="dialog = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="submit">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

import DatePickerForm from '../../../common/ui/DatePickerForm'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../mixins/createEntityMixin'

export default {
  components: {
    DatePickerForm
  },

  mixins: [
    validationMixin,
    createEntityMixin
  ],

  props: {
    condicionId: [String, Number],
    fechaInicioMinima: String
  },

  data () {
    return {
      dialog: false,
      fechaCierre: null,
      motivoCierre: null
    }
  },

  validations: {
    fechaCierre: { required },
    motivoCierre: { required }
  },

  computed: {
    fechaCierreErrors () {
      let errors = this.getRequiredErrors('fechaCierre')
      return errors
    },
    motivoCierreErrors () {
      return this.getRequiredErrors('motivoCierre')
    }
  },

  methods: {
    openDialog () {
      this.dialog = true
    },
    getPayload () {
      const payload = {
        fechaCierre: this.fechaCierre,
        motivoCierre: this.motivoCierre }
      return payload
    },
    isValidForm () {
      return !this.$v.$invalid
    },
    submit () {
      this.$v.$touch()
      if (this.isValidForm()) {
        let payload = this.getPayload()

        this.axios
          .put(`condicion/terminar/${this.condicionId}`, payload)
          .then(response => {
            this.dialog = false
            this.$emit('condicionTerminada')
          })
          .catch(error => { this.$store.commit('setErrorMsg', error) })
      }
    }
  }
}
</script>
